export default function StatusPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100">
      <h1 className="text-4xl font-bold mb-4">Status Page</h1>
      <p className="text-lg text-gray-700 mb-8">Check the current status of our services and uptime.</p>
    </div>
  )
}
